import React, { useState, useEffect } from 'react';
import { Ads } from '../services/adsService';
import styles from './AdsMarquee.module.scss';
import { BACKEND_BASE_URL } from '../utils/constants';

interface AdsProps {
  instructions: Ads[];
}

const AdsnMarquee: React.FC<AdsProps> = ({ instructions = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!instructions || instructions.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % instructions.length);
    }, 5000); // Change instruction every 5 seconds

    return () => clearInterval(interval);
  }, [instructions]);

  // if (!instructions || instructions.length === 0) {
  //   return (
  //     <div className={styles.marqueeContainer}>
  //       <div className={styles.noInstructions}>
  //         <p>No active ads available</p>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className={styles.marqueeContainer}>
      <div className={styles.marqueeContent}>
        <div className={styles.instructionSlide}>
          {instructions[currentIndex]?.image_url && (
            <div className={styles.instructionImage}>
              <img
                src={BACKEND_BASE_URL+ '/documents/' + instructions[currentIndex].image_url}
                alt="Ads"
                className={styles.instructionImageTag}
              />
            </div>
          )}
        </div>
      </div>
      {/* {instructions.length > 1 && (
        <div className={styles.marqueeIndicators}>
          {instructions.map((_, index) => (
            <button
              key={index}
              className={`${styles.indicator} ${index === currentIndex ? styles.active : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      )} */}
    </div>
  );
};

export default AdsnMarquee; 